import { render, staticRenderFns } from "./showDetails.vue?vue&type=template&id=a997a5e0&scoped=true"
import script from "./showDetails.vue?vue&type=script&lang=js"
export * from "./showDetails.vue?vue&type=script&lang=js"
import style0 from "./showDetails.vue?vue&type=style&index=0&id=a997a5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a997a5e0",
  null
  
)

export default component.exports